import * as Yup from 'yup'
import {
    dateTimeFormatFunction,
    formatPhone,
    dateFormatFunction,
    dateFormatFrontTime,
} from '../../../../common/components'
import Cryptos from '@/product/common/cryptos'
import moment from 'moment'

export const validationFunction = (arrayValue, customValidation, t) => {
    let handle = {}
    arrayValue
        .filter((data) => (data.active ? data.active === 1 : true))
        .map((data, index) => {
            // 'date','month','time'

            if (customValidation && customValidation[data.name]) {
                handle[data.name] = customValidation[data.name]
            } else {
                if (
                    data.type === 'radio' ||
                    data.type === 'text' ||
                    data.type === 'email' ||
                    data.type === 'select' ||
                    data.type === 'searchdrop' ||
                    (data.type === 'autocomplete' && !data.multiple)
                ) {
                    if (data.is_required) {
                        handle[data.name] = Yup.string().required(
                            t('Required!')
                        )
                    } else {
                        handle[data.name] = Yup.string()
                    }
                }

                if (data.name === 'password') {
                    handle[data.name] = Yup.string()
                        .min(8, 'Minimum 8 characters')
                        .required(t('Required!'))
                }

                if (data.name === 'confirm_password') {
                    handle[data.name] = Yup.string()
                        .oneOf([Yup.ref('password')], 'Passwords not match')
                        .required(t('Required!'))
                }

                if (data.type === 'checkboxarray') {
                    if (data.is_required) {
                        handle[data.name] = Yup.array()
                            .nullable()
                            .required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.array().nullable()
                    }
                }

                if (data.type === 'textarea') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string()
                            .nullable()
                            .required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.string().nullable()
                    }
                }

                if (data.type === 'check') {
                    if (data.is_required) {
                        handle[data.name] = Yup.array()
                            .nullable()
                            .required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.array().nullable()
                    }
                }

                if (data.type === 'phone') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string()
                            .nullable()
                            .required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.string().nullable()
                    }
                }
                if (data.type === 'date') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string()
                            .required(t('Required!'))
                            .nullable()
                    } else {
                        handle[data.name] = Yup.string().nullable()
                    }
                }

                if (data.type === 'time') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string()
                            .required(t('Required!'))
                            .nullable()
                    } else {
                        handle[data.name] = Yup.string().nullable()
                    }
                }

                if (data.type === 'datetime') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string()
                            .required(t('Required!'))
                            .nullable()
                    } else {
                        handle[data.name] = Yup.string().nullable()
                    }
                }

                if (data.type === 'checkbox') {
                    if (data.is_required) {
                        handle[data.name] = Yup.boolean().required(
                            t('Required!')
                        )
                    } else {
                        handle[data.name] = Yup.boolean()
                    }
                }

                if (data.type === 'multiselect') {
                    if (data.is_required) {
                        handle[data.name] = Yup.array().required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.array()
                    }
                }

                if (data.type === 'number') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string().required(
                            t('Required!')
                        )
                    } else {
                        handle[data.name] = Yup.string()
                    }
                }

                if (
                    data.type === 'ckeditor' ||
                    data.type === 'tinymce' ||
                    data.type === 'ckeditor5'
                ) {
                    if (data.is_required) {
                        handle[data.name] = Yup.string().required('Required')
                    } else {
                        handle[data.name] = Yup.string()
                    }
                }
                if (data.type === 'float') {
                    if (data.is_required) {
                        handle[data.name] = Yup.number()
                            .required('Required')
                            .test(
                                'is-decimal',
                                'Invalid Decimal Value',
                                (value) => /^\d+(\.\d{1,2})?$/.test(value)
                            )
                    } else {
                        handle[data.name] = Yup.number().test(
                            'is-decimal',
                            'Invalid Decimal Value',
                            (value) => {
                                if (value) {
                                    return /^\d+(\.\d{1,2})?$/.test(value)
                                } else {
                                    return true
                                }
                            }
                        )
                    }
                }

                if (data.type === 'uploadDropZone') {
                    if (data.is_required) {
                        handle[data.name] = Yup.array().required(t('Required!'))
                    } else {
                        handle[data.name] = Yup.array()
                    }
                }

                if (data.type === 'switch') {
                    if (data.is_required) {
                        handle[data.name] = Yup.boolean().required(
                            t('Required!')
                        )
                    } else {
                        handle[data.name] = Yup.boolean()
                    }
                }
                if (data.type === 'multipleArrayValue') {
                    if (data.is_required) {
                        handle[data.name] = Yup.string().required(
                            t('Required!')
                        )
                    } else {
                        handle[data.name] = Yup.string()
                    }
                }
            }
        })

    return handle
}

export const initialFunction = (
    arrayValue,
    alldata_all_dropdown,
    subLevelOptions,
    allCountries,
    subStateOptions,
    subCityOptions,
    allLocations,
    allCategory
) => {
    let show = {}
    let tempMapData = []
    let calculateValues = []
    arrayValue
        .filter((data) => (data.active ? data.active === 1 : true))
        .map((data, index) => {
            let mapValue = {}

            if (data.type !== 'default' && data.type !== 'custom') {
                mapValue.name = data.name
                mapValue.type = data.type
                mapValue.label = data.label
                mapValue.placeholder = data.placeholder
                mapValue.class = data.class
                mapValue.content = data.content
                mapValue.scanBarcode = data.scanBarcode
                mapValue.disabled = data.disabled
                mapValue.calculate = data.calculate
                mapValue.calculate_value = data.calculate_value
                mapValue.icon_only = data.icon_only
                mapValue.id = data.id ? data.id : null
                mapValue.onWheelHide = data.onWheelHide
                    ? data.onWheelHide
                    : false
                mapValue.disablePast = data?.disablePast
                mapValue.customDateFormat = data?.customDateFormat
                mapValue.disableFuture = data?.disableFuture
                mapValue.placeID = data?.placeID
                mapValue.fullAddress = data?.fullAddress
            } else {
                mapValue = null
            }

            if (data.type === 'colorpicker') {
                mapValue.defaultColors = data.defaultColors || null
            }
            if (data.type === 'datetime') {
                mapValue.disablePast = data.disablePast
                    ? data.disablePast
                    : false
            }

            if (data.type == 'hiddenMask') {
                mapValue.tooltiptitle =
                    'Please click on the edit icon to enable the field.'
                mapValue.disableHoverListener = false
                mapValue.last4Masked = true
                mapValue.customEndAdornmentOff = 'edit'
                mapValue.customEndAdornmentOn = 'edit_off'
            }

            if (data.type == 'uploadDropZone') {
                mapValue.folder = data.folder || 'product'
                mapValue.multiple = data.multiple || false
                mapValue.reorder = data.reorder || false
                mapValue.accept = data.accept || ''
                mapValue.titleText = data.label
                mapValue.avatar = data.avatar ? data.avatar : false
                mapValue.innerText = data.placeholder
                mapValue.object_image = data.object_image || 0
                mapValue.isCompress = data.is_compress === 1 ? 'true' : 0 || 0
                mapValue.quality = data.compress_quality || 0
                mapValue.resultWidth = data.compress_width || 0
                mapValue.resultHeight = data.compress_height || 0
                mapValue.webcam = data.webcam ? data.webcam : false
                mapValue.isCrop = data.isCrop ? data.isCrop : false
            }

            if (data.type == 'multipleArrayValue') {
                mapValue.fields = data.fields
                mapValue.subname = data.subname
            }

            if (data.type === 'autocomplete') {
                mapValue.options = data.options
                mapValue.multiple = data.multiple
                mapValue.onClear = data.onClear
            }

            if (data.type === 'searchdrop') {
                mapValue.getAllOptions = data.getAllOptions
                mapValue.options = data.options
                mapValue.forcePopupIcon = data?.forcePopupIcon
                mapValue.focused = data?.focused
                mapValue.onClearDefault = data?.onClearDefault
            }
            if (data.type === 'select' && parseInt(data.sub_select, 10) !== 1) {
                mapValue.upperLabel = data?.upperLabel
                if (data.options) {
                    mapValue.options = data.options
                } else {
                    if (data?.isCategory && allCategory?.length) {
                        mapValue.options = allCategory
                            .filter(
                                (value) =>
                                    value.active === 1 && value.level === 0
                            )
                            .sort((a, b) => a.show_order - b.show_order)
                            .map((item) => {
                                let valueChanged = {}
                                valueChanged.show = item.description
                                valueChanged.value = item.id
                                return valueChanged
                            })
                    } else {
                        mapValue.options = alldata_all_dropdown
                            .filter(
                                (value) =>
                                    value.variable === data.name &&
                                    value.level === 0
                            )
                            .sort((a, b) => a.show_order - b.show_order)
                            .map((item) => {
                                let valueChanged = {}
                                valueChanged.show = item.description
                                valueChanged.value = data.diff_value
                                    ? item.value
                                    : item.id
                                return valueChanged
                            })
                    }
                }
            }
            if (data.type === 'radio') {
                mapValue.int = 1
                mapValue.title = data.label
            }

            if (data.type === 'checkboxarray' || data.type === 'radio') {
                mapValue.item = alldata_all_dropdown
                    .filter((value) => value.variable === data.name)
                    .sort((a, b) => a.show_order - b.show_order)
                    .map((item) => {
                        let valueChanged = {}
                        valueChanged.description = item.description
                        valueChanged.id = item.id
                        return valueChanged
                    })
            }
            if (
                data.type == 'multiselect' &&
                parseInt(data.country, 10) === 1
            ) {
                mapValue.options = allCountries
                    .filter(
                        (country) =>
                            global.ignoreCountry.indexOf(country.isoCode) === -1
                    )
                    .map((country) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = country.name
                        busCategoryChanged.value = country.isoCode
                        return busCategoryChanged
                    })
            }
            if (
                data.type === 'multiselect' &&
                data.name !== 'project_id' &&
                data.country !== 1 &&
                parseInt(data.sub_select, 10) !== 1
            ) {
                if (data.ignoreDropValues) {
                    mapValue.options = alldata_all_dropdown
                        .filter(
                            (value) =>
                                value.variable === data.name &&
                                value.id !== data.ignoreDropValues
                        )
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.show = item.description
                            valueChanged.value = data.diff_value
                                ? item.value
                                : item.id
                            return valueChanged
                        })
                } else if (
                    data.options &&
                    data.options.length &&
                    data.customOptions
                ) {
                    mapValue.options = data.options
                } else {
                    mapValue.options = alldata_all_dropdown
                        .filter((value) => value.variable === data.name)
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.show = item.description
                            valueChanged.value = data.diff_value
                                ? item.value
                                : item.id
                            return valueChanged
                        })
                }
            }

            if (data.type === 'multiselect' && data.name === 'project_id') {
                mapValue.options = data.options ? data.options : []
            }

            if (
                data.type === 'multiselect' &&
                parseInt(data.sub_select, 10) === 1
            ) {
                mapValue.sub_select = data.sub_select
                mapValue.sub_level = data.sub_level
                mapValue.sub_field = data.sub_field
                mapValue.diff_value = data.diff_value

                if (parseInt(data.sub_level, 10) === 0) {
                    mapValue.options = alldata_all_dropdown
                        .filter(
                            (maincat) =>
                                maincat.variable === data.name &&
                                maincat.level === 0
                        )
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((maincat) => {
                            let categoryChanged = {}
                            categoryChanged.show = maincat.description
                            categoryChanged.value = data.diff_value
                                ? maincat.value
                                : maincat.id
                            return categoryChanged
                        })
                } else if (parseInt(data.sub_level, 10) > 0) {
                    let optionValue = subLevelOptions(data)
                    if (optionValue?.length) {
                        mapValue.options = subLevelOptions(data)
                    } else {
                        mapValue.options = []
                    }
                }
            }
            if (data.calculate) {
                calculateValues.push(data)
            }

            // 'date','month','time'

            if (data.initialDefault) {
                show[data.name] = data.initialDefault
            } else {
                if (
                    data.type === 'radio' ||
                    data.type === 'text' ||
                    data.type === 'email' ||
                    data.type === 'select' ||
                    data.type === 'searchdrop' ||
                    (data.type === 'autocomplete' && !data.multiple)
                ) {
                    if (parseInt(data.country, 10) === 1) {
                        show[data.name] = global?.defaultCountry
                            ? global.defaultCountry
                            : ''
                    } else {
                        show[data.name] = ''
                    }
                }

                if (data.name === 'password') {
                    show[data.name] = ''
                }

                if (data.name === 'confirm_password') {
                    show[data.name] = ''
                }

                if (data.type === 'checkboxarray') {
                    show[data.name] = []
                }

                if (data.type === 'textarea') {
                    show[data.name] = ''
                }

                if (data.type === 'check') {
                    show[data.name] = []
                }

                if (data.type === 'phone') {
                    show[data.name] = ''
                }

                if (data.type === 'datetime') {
                    show[data.name] = null
                }
                if (data.type === 'date') {
                    show[data.name] = null
                }

                if (data.type === 'time') {
                    show[data.name] = null
                }

                if (data.type === 'checkbox') {
                    show[data.name] = false
                }

                if (data.type === 'multiselect') {
                    show[data.name] = []
                }
                if (data.type === 'multidate') {
                    show[data.name] = []
                }

                if (data.type === 'number' || data.type === 'float') {
                    show[data.name] = ''
                }

                if (data.type === 'ckeditor' || data.type === 'ckeditor5') {
                    show[data.name] = ''
                }

                if (data.type === 'tinymce') {
                    show[data.name] = ''
                }

                if (data.type === 'uploadDropZone') {
                    show[data.name] = []
                }

                if (data.type === 'switch') {
                    show[data.name] = false
                }

                if (data.type === 'default') {
                    show[data.name] = data.value
                }

                if (data.type === 'custom') {
                    show[data.name] = data.value
                }
                if (data.type === 'multipleArrayValue') {
                    show[data.name] = []
                }
            }

            if (data.type === 'select' && parseInt(data.sub_select, 10) === 1) {
                mapValue.sub_select = data.sub_select
                mapValue.sub_level = data.sub_level
                mapValue.sub_field = data.sub_field

                if (parseInt(data.sub_level, 10) === 0) {
                    mapValue.options = alldata_all_dropdown
                        .filter(
                            (maincat) =>
                                maincat.variable === data.name &&
                                maincat.level === 0
                        )
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((maincat) => {
                            let categoryChanged = {}
                            categoryChanged.show = maincat.description
                            categoryChanged.value = data.diff_value
                                ? maincat.value
                                : maincat.id
                            return categoryChanged
                        })
                } else if (parseInt(data.sub_level, 10) > 0) {
                    let optionValue = subLevelOptions(data)
                    if (optionValue.length) {
                        mapValue.options = optionValue
                    } else {
                        mapValue.options = []
                    }
                }
            }

            if (data.type == 'select' && parseInt(data.country, 10) === 1) {
                mapValue.options = allCountries
                    .filter(
                        (country) =>
                            global.ignoreCountry.indexOf(country.isoCode) === -1
                    )
                    .map((country) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = country.name
                        busCategoryChanged.value = country.isoCode
                        return busCategoryChanged
                    })
            }
            if (data.type == 'select' && parseInt(data.location, 10) === 1) {
                if (data.seller && data.admin_id) {
                    mapValue.options = allLocations
                        .filter((value) =>
                            data?.emp_location
                                ? data.emp_location
                                      .split(',')
                                      .includes(value.id.toString())
                                : value.admin_id == data.admin_id
                        )
                        .map((location) => {
                            let locationChanged = {}
                            locationChanged.show =
                                location.description || location.name
                            locationChanged.value = location.id
                            return locationChanged
                        })
                } else {
                    mapValue.options = allLocations.map((location) => {
                        let locationChanged = {}
                        locationChanged.show =
                            location.description || location.name
                        locationChanged.value = location.id
                        return locationChanged
                    })
                }
            }
            if (data.type == 'select' && parseInt(data.state, 10) === 1) {
                mapValue.options = subStateOptions(data)
            }
            if (data.type == 'select' && parseInt(data.city, 10) === 1) {
                mapValue.options = subCityOptions(data)
            }

            if (
                data.type == 'multiselect' &&
                parseInt(data.location, 10) === 1
            ) {
                if (data.seller && data.admin_id) {
                    mapValue.options = allLocations
                        .filter(
                            (value) =>
                                value.active === 1 &&
                                value.admin_id == data.admin_id
                        )
                        .map((location) => {
                            let locationChanged = {}
                            locationChanged.show =
                                location.description || location.name
                            locationChanged.value = location.id
                            return locationChanged
                        })
                } else {
                    mapValue.options = allLocations
                        .filter((value) => value.active === 1)
                        .map((location) => {
                            let locationChanged = {}
                            locationChanged.show =
                                location.description || location.name
                            locationChanged.value = location.id
                            return locationChanged
                        })
                }
            }

            if (mapValue) {
                tempMapData.push(mapValue)
            }
        })

    return { tempMapData, show, calculateValues }
}

export const editValue = (arrayValue, editData, employessEmailUpdate) => {
    const objectPush = {}
    arrayValue
        .filter((data) => (data.active ? data.active === 1 : true))
        .map((data, index) => {
            objectPush.id = editData.id ? editData.id : 0

            if (employessEmailUpdate) {
                objectPush.admin = editData?.admin ? editData.admin : 0
                objectPush.as_employees_id = editData?.as_employees_id
                    ? editData.as_employees_id
                    : 0
            }
            // {
            //     console.log(
            //         'project_id 111',
            //         editData[data.name],
            //         data.type,
            //         data
            //     )
            // }
            objectPush.multiArrayObject = editData.multipleArrayValue
                ? editData.multipleArrayValue.damage_items.data
                : []
            if (data.type != 'misc') {
                if (data.initialDefault && editData[data.name]) {
                    objectPush[data.name] = editData[data.name]
                        ? editData[data.name]
                        : data.initialDefault
                } else {
                    if (
                        data.type == 'imagewithurl' ||
                        data.type == 'uploadDropZone'
                    ) {
                        if (data.object_image) {
                            objectPush[data.name] = editData[data.name]
                                ? JSON.parse(editData[data.name].toString())
                                : []
                        } else if (data.avatar) {
                            objectPush[data.name] = editData.avatar
                                ? [editData.avatar]
                                : []
                        } else {
                            objectPush[data.name] = editData[data.name]
                                ? editData[data.name].toString().split(',')
                                : []
                        }
                    } else if (data.type == 'datetime') {
                        objectPush[data.name] = editData[data.name]
                            ? dateTimeFormatFunction(editData[data.name], true)
                            : null
                    } else if (data.type == 'number') {
                        if (data.formatPhone) {
                            objectPush[data.name] = formatPhone(
                                editData[data.name],
                                true
                            )
                        } else {
                            objectPush[data.name] = editData[data.name]
                                ? editData[data.name]
                                : 0
                        }
                    } else if (data.type == 'checkbox') {
                        objectPush[data.name] = editData[data.name]
                            ? editData[data.name]
                            : false
                    } else if (
                        data.type == 'multiselect' &&
                        data.name === 'project_id'
                    ) {
                        objectPush[data.name] = editData.auction_lots
                            ? editData.auction_lots.split(',').map(Number)
                            : []
                    } else if (
                        data.type == 'multiselect' &&
                        data.name !== 'project_id'
                    ) {
                        if (data.diff_value) {
                            objectPush[data.name] = editData[data.name]
                                ? editData[data.name].split(',').map(String)
                                : []
                        } else {
                            objectPush[data.name] = editData[data.name]?.length
                                ? editData[data.name].split(',').map(Number)
                                : []
                        }
                    } else if (data.type == 'multipleArrayValue') {
                        objectPush[data.name] = editData[data.name]
                            ? editData[data.name]
                            : []
                    } else if (data.type == 'multidate') {
                        objectPush[data.name] = editData[data.name]
                            ? editData[data.name]?.split(',').map((d) => d)
                            : []
                    } else if (data.type == 'date') {
                        objectPush[data.name] = editData[data.name]
                            ? dateFormatFunction(editData[data.name], true)
                            : null
                    } else if (data.type == 'time') {
                        if (data?.customTime) {
                            objectPush[data.name] = editData[data.name]
                                ? moment(editData[data.name], 'HH:mm').format(
                                      'hh:mm A'
                                  ) // 16:00 → 04:00 PM
                                : null
                        } else {
                            objectPush[data.name] = editData[data.name]
                                ? dateFormatFrontTime(editData[data.name], true)
                                : null
                        }
                    } else if (data.type == 'hiddenMask') {
                        objectPush[data.name] = editData[data.name]
                            ? Cryptos.decrypt(editData[data.name]) || ''
                            : ''
                    } else {
                        if (data.formatPhone) {
                            objectPush[data.name] = formatPhone(
                                editData[data.name],
                                true
                            )
                        } else {
                            objectPush[data.name] = editData[data.name]
                                ? editData[data.name]
                                : ''
                        }
                    }
                }
            }
        })
    return objectPush
}

export const initialFilterFunction = (arrayValue) => {
    let show = {}

    function setTableShortValue(data) {
        switch (data.view_page) {
            case '1':
                if (data.template) {
                    if (data.is_default) {
                        show[data.field].field = `tp.${data.field}`
                    } else {
                        show[data.field].field = `tcp.${data.field}`
                    }
                } else {
                    if (data.filterField) {
                        show[data.field].field = data.filterField
                    } else if (data.is_default) {
                        show[data.field].field = `p.${data.field}`
                    } else {
                        show[data.field].field = `it.${data.field}`
                    }
                }
                break
            case '2':
                if (data.template) {
                    if (data.is_default) {
                        show[data.field].field = `tac.${data.field}`
                    } else {
                        show[data.field].field = `tcac.${data.field}`
                    }
                } else {
                    if (data.is_default) {
                        show[data.field].field = `ac.${data.field}`
                    } else {
                        show[data.field].field = `cac.${data.field}`
                    }
                }
                break
            case '3':
                if (data.is_default && data.additional_field) {
                    show[data.field].field =
                        `u.${data.field},${data.additional_field}`
                } else if (data.is_default) {
                    show[data.field].field = `u.${data.field}`
                } else {
                    show[data.field].field = `cu.${data.field}`
                }
                break
            case '4':
                if (data.is_default) {
                    show[data.field].field = `tp.${data.field}`
                } else {
                    show[data.field].field = `tcp.${data.field}`
                }
                break

            default:
                if (data.filterField) {
                    show[data.field].field = data.filterField
                }
                break
        }
    }

    arrayValue
        .filter((data) => (data.active ? data.active === 1 : true))
        .map((data, index) => {
            show[data.field] = {}
            show[data.field].type = data.filter_type

            if (
                data.type === 'text' ||
                data.type === 'select' ||
                data.type === 'hyperlink'
            ) {
                show[data.field].value = ''
                setTableShortValue(data)
            }

            if (data.type === 'datetime') {
                show[data.field].value = ''
                setTableShortValue(data)
            }

            if (data.type === 'email') {
                show[data.field].value = ''
                setTableShortValue(data)
            }
            if (data.type === 'date') {
                show[data.field].value = ''
                setTableShortValue(data)
            }
            if (data.type === 'switch') {
                show[data.field].value = ''
                setTableShortValue(data)
            }
        })

    return show
}
